import React from 'react'
import Helmet from 'react-helmet'
import { rgba, darken } from 'polished'
import PropTypes from 'prop-types'
import theme from '../utils/theme'
import {
  globalStyle,
  createGlobalStyle,
  ThemeProvider,
  th,
} from '@smooth-ui/core-sc'

const siteData = {
  title: 'Muhsis, Destek & Yardım Merkezi',
  description:
    "Muhsis, küçük ve orta ölçekli firmalar için, web tabanlı, yeni nesil bir ticari yazılım çözümüdür. Muhsis'in kullanımı ile ilgili video, makale ve diğer içeriklere buradan ulaşabilirsiniz",
}

const GlobalStyle = createGlobalStyle`
  ${globalStyle()}

  body {
    background-color: ${th('white')};
    color: ${th('gray1100', c => rgba(c, 0.8))};
    font-family: ${theme.fontFamily};
  }

  a {
    color: ${th('primary')};
    transition: color .15s;

    &:hover {
      color: ${th('primary', c => darken(0.1, c))};
    }
  }

  h1, h2, h3, h4, h5, h6 {
    font-weight: 700;
  }

  ::selection {
    background: ${th('primary', c => rgba(c, 0.25))};
    text-shadow: none;
  }
`

const Layout = ({ children }) => (
  <ThemeProvider theme={theme}>
    <>
      <Helmet title={siteData.title}>
        <meta name="description" content={siteData.description} />
        <meta property="og:type" content="article" />
        <meta property="og:title" content={siteData.title} />
        <meta property="og:description" content={siteData.description} />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={siteData.title} />
        <meta name="twitter:description" content={siteData.description} />
      </Helmet>

      <GlobalStyle />
      {children}
    </>
  </ThemeProvider>
)

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
